import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ToastContainer } from 'react-toastify'
import { ErrorBoundary } from '@appsignal/react'

import createStore from 'store'
import Routes from 'containers/Routes'
import OAuthIframe from 'containers/OAuthCallback/OAuthIframe'
import { appsignal } from 'resources/appsignal'

import 'react-toastify/dist/ReactToastify.css'

const { store, persistor } = createStore()

function App() {
  return (
    <ErrorBoundary instance={appsignal}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <OAuthIframe />
          <Routes />
          <ToastContainer
            autoClose={5000}
            position="bottom-left"
            hideProgressBar={true}
            theme="colored"
            icon={false}
            closeButton={false}
            closeOnClick={true}
          />
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  )
}

export default App
